import React from 'react';
import { useSelector } from 'react-redux';

import { logoutUser } from '@app/dev/helpers/verification';
import { useTranslation } from '@common/hooks/translation';

const VerificationAccount = () => {
  const { verification } = useSelector((state) => state.user);
  const t = useTranslation();

  if (!verification?.data) return null;

  const { data: { name, documentNumber } } = verification;

  return (
    <div className="verification-account">
      <p className="Verification-info">
        <i className="global-icon icon-profile user-icon" />
        {name || '-'}
        {!!documentNumber && `${t('DNI - ')} ${documentNumber || '-'}`}
      </p>
      <i className="global-icon icon-logout verification-logout" onClick={logoutUser} />
    </div>
  );
};

export default VerificationAccount;
